export let NotificationLevel;
(function (NotificationLevel) {
  NotificationLevel["Success"] = "success";
  NotificationLevel["Info"] = "info";
  NotificationLevel["Warning"] = "warn";
  NotificationLevel["Error"] = "error";
})(NotificationLevel || (NotificationLevel = {}));